import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };
  
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-light mb-4">SouleMap</h3>
            <p className="text-gray-400 text-sm font-light leading-relaxed">
              Honoring lives, preserving memories forever.
            </p>
          </div>
          
          {/* Legal Links */}
          <div>
            <h4 className="text-xs font-medium uppercase tracking-wider mb-6">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/legal/terms" onClick={handleLinkClick} className="text-gray-400 hover:text-white text-sm transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/legal/privacy" onClick={handleLinkClick} className="text-gray-400 hover:text-white text-sm transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/legal/donation" onClick={handleLinkClick} className="text-gray-400 hover:text-white text-sm transition-colors">
                  Donation Agreement
                </Link>
              </li>
              <li>
                <Link to="/legal/community" onClick={handleLinkClick} className="text-gray-400 hover:text-white text-sm transition-colors">
                  Community Guidelines
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Support Links */}
          <div>
            <h4 className="text-xs font-medium uppercase tracking-wider mb-6">Support</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/help" onClick={handleLinkClick} className="text-gray-400 hover:text-white text-sm transition-colors">
                  Help Center
                </Link>
              </li>
              <li>
                <Link to="/faq" onClick={handleLinkClick} className="text-gray-400 hover:text-white text-sm transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <a href="mailto:support@soulemap.com" className="text-gray-400 hover:text-white text-sm transition-colors">
                  support@soulemap.com
                </a>
              </li>
            </ul>
          </div>
          
          {/* Company Links */}
          <div>
            <h4 className="text-xs font-medium uppercase tracking-wider mb-6">Company</h4>
            <ul className="space-y-3">
              <li>
                {/* Plain <a> on purpose: /souls is a server-rendered,
                    crawlable directory outside the React app */}
                <a href="/souls" className="text-gray-400 hover:text-white text-sm transition-colors">
                  The Memorial Directory
                </a>
              </li>
              <li>
                <Link to="/about" onClick={handleLinkClick} className="text-gray-400 hover:text-white text-sm transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <a href="mailto:fraud@soulemap.com?subject=Fraud%20Report%20-%20Memorial%20ID%3A%20[PLEASE%20ADD]&body=Please%20include%20the%20Memorial%20ID%20from%20the%20memorial%20page%20URL%20(e.g.%2C%20mem_xxxxx)%20and%20describe%20the%20fraudulent%20activity." className="text-gray-400 hover:text-white text-sm transition-colors">
                  Report Fraud
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-16 pt-8 border-t border-gray-800">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <p className="text-sm text-gray-400">
                © {currentYear} SouleMap, LLC. All rights reserved.
              </p>
              <p className="text-sm text-gray-400 mt-2">
                Platform Terms Apply. User Content Subject to Terms.
              </p>
            </div>
            
            {/* Fraud Notice */}
            <div className="md:text-right">
              <p className="text-xs text-gray-500 uppercase tracking-wider mb-2">Important Notice</p>
              <p className="text-sm text-gray-400">
                SouleMap does not verify memorials. Users are responsible for due diligence.
              </p>
              <p className="text-sm text-gray-400">
                Report suspicious activity to <a href="mailto:fraud@soulemap.com?subject=Fraud%20Report%20-%20Memorial%20ID%3A%20[PLEASE%20ADD]&body=Please%20include%20the%20Memorial%20ID%20from%20the%20memorial%20page%20URL%20(e.g.%2C%20mem_xxxxx)%20and%20describe%20the%20fraudulent%20activity." className="text-white hover:text-gray-300 transition-colors">fraud@soulemap.com</a>
              </p>
              <p className="text-xs text-gray-500 mt-1">
                Include Memorial ID when reporting (found in memorial URL)
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;